<template>
    <div class="form">
        <h4 class="step-title">
            Are these your vehicles?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <div class="step-item">
                <div class="form-group mb-0">
                    <template v-for="(vehicle, vehicleNum) in lead.pendingVehicles">
                        <div class="m-2" v-bind:key="vehicleNum">
                            <div class="input-group mb-3">
                                <input type="text" class="form-control" readonly v-bind:value="getVehicleDescription(vehicle)">
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <input type="checkbox" class="vehicle-checkbox" v-model="vehicle.selected">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="step-item">
                <div class="form-group mb-0">
                    <div class="step-item col-12">
                        <button class="btn step-btn form-control" v-on:click="complete(true)">Yes</button>
                    </div>
                    <div class="step-item col-12">
                        <button class="btn step-btn form-control" v-on:click="complete(false)">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "VehicleConfirmation",
        props: {
            lead: Object
        },
        methods: {
            getVehicleDescription: function(vehicle) {
                var vehicleDescription = vehicle.year + " " + vehicle.make + " " + vehicle.model;

                if (vehicle.trim) {
                    vehicleDescription += " " + vehicle.trim;
                }

                return vehicleDescription;
            },
            complete: function(value) {
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>

<style scoped>

.step-item {
    width: 100% !important;
    max-width: 500px;
}

.vehicle-checkbox {
    transform: scale(1.5);
}

</style>
